export const getUserSlug = () =>
  (localStorage.getItem("user_slug") || "").trim();



// WEBPACK FOOTER //
// ./src/util/getUserSlug.ts